function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isEqual } from 'date-fns';
import { noop } from './utils';
import DateTable from './date/dateTable.js';
import MonthTable from './month/monthTable';
export default {
  name: 'FullCalendar',
  inheritAttrs: false,
  props: {
    prefixCls: {
      type: String,
      default: 'v-calendar'
    },
    value: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    locale: {
      type: Object,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'date'
    },
    monthCellRender: {
      type: Function,
      default: null
    },
    dateCellRender: {
      type: Function,
      default: null
    },
    disabledDate: {
      type: Function,
      default: noop
    },
    format: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      innerValue: null,
      selectedValue: null
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          fullscreen = this.fullscreen;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-full"), true), _defineProperty(_ref, "".concat(prefixCls, "-fullscreen"), !!fullscreen), _ref;
    }
  },
  watch: {
    value: function value(nVal) {
      this.updateValue(nVal, {}, false);
    }
  },
  created: function created() {
    var updateValue = this.updateValue,
        value = this.value;
    updateValue(value, {}, false);
  },
  methods: {
    updateValue: function updateValue(value, from) {
      var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var setInnerValue = this.setInnerValue,
          setSelectedValue = this.setSelectedValue;
      setInnerValue(value, trigger);
      setSelectedValue(value, from, trigger);
    },
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var innerValue = this.innerValue;

      if (!isEqual(value, innerValue)) {
        this.innerValue = value;

        if (trigger) {
          this.$emit('input', value);
          this.$emit('change', value);
        }
      }
    },
    setSelectedValue: function setSelectedValue(value) {
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.selectedValue = value;

      if (trigger) {
        this.$emit('select', value, from);
      }
    },
    onSelect: function onSelect(value) {
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        target: 'date'
      };
      this.updateValue(value, from, true);
    },
    onMonthSelect: function onMonthSelect(value) {
      this.onSelect(value, {
        target: 'month'
      });
    },
    renderCalendar: function renderCalendar() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          format = this.format,
          innerValue = this.innerValue,
          type = this.type,
          locale = this.locale,
          disabledDate = this.disabledDate,
          dateCellRender = this.dateCellRender,
          dateCellContentRender = this.dateCellContentRender,
          monthCellRender = this.monthCellRender,
          monthCellContentRender = this.monthCellContentRender,
          onSelect = this.onSelect,
          onMonthSelect = this.onMonthSelect;
      var props = {
        locale: locale,
        value: innerValue,
        selectedValue: innerValue
      };
      var table = null;

      if (type === 'date') {
        props = _objectSpread({}, props, {
          prefixCls: prefixCls,
          dateRender: dateCellRender,
          contentRender: dateCellContentRender,
          disabledDate: disabledDate,
          format: format
        });
        table = h(DateTable, {
          "props": _objectSpread({}, props),
          "on": _objectSpread({}, {
            select: onSelect
          })
        });
      } else {
        props = _objectSpread({}, props, {
          prefixCls: "".concat(prefixCls, "-month-panel"),
          monthRender: monthCellRender,
          contentRender: monthCellContentRender,
          disabledMonth: disabledDate
        });
        table = h(MonthTable, {
          "props": _objectSpread({}, props),
          "on": _objectSpread({}, {
            select: onMonthSelect
          })
        });
      }

      return h("div", {
        "key": "calendar-body",
        "class": "".concat(prefixCls, "-calendar-body")
      }, [table]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        renderCalendar = this.renderCalendar;
    return h("div", {
      "class": classes
    }, [renderCalendar()]);
  }
};